import React from "react";

/**
 * @param {String} header - The header of the section
 * @param {HTML} content - The content of the section
 */
function Section(props) {
  return (
    <div className="section">
      <h1 style={{ textAlign: props.alignCenter ? "center" : "left" }}>
        {props.header}
      </h1>
      {props.content}
    </div>
  );
}

export default Section;
